import { render, staticRenderFns } from "./vsDropdown.vue?vue&type=template&id=453aad54&lang=html"
import script from "./vsDropdown.vue?vue&type=script&lang=js"
export * from "./vsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports